import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { icon } from "../../../../../../config";
import { EXPRESSION_LABELS } from "../../../constants/expressionBuilder.constants";
import "../../../styles/ExpressionBuilder.css";

/**
 * Component for rendering expression builder modal header
 * @param {Function} onClose - Close handler function
 * @returns {JSX.Element} Modal header component
 * @author Abhishek Dhillon
 * @parent ExpressionBuilderModal
 */
const ModalHeader = ({ onClose, title = "Switch Node Configuration" }) => {
  return (
    <div className='expression-builder-modal-header d-flex px-3 py-2'>
      <h5 className='modal-title d-flex align-items-center mb-0'>
        {icon.SETTINGS}
        <span className='expression-builder-ms-2'>{title}</span>
      </h5>
      <Button
        onClick={onClose}
        icon='close'
        fillMode='flat'
        className='btn-close ms-auto'
        id='close-switch-popup'
        title={EXPRESSION_LABELS.CLOSE_MODAL}
      />
    </div>
  );
};

export default ModalHeader;
